export default __webpack_public_path__ + "images/eb96bc621720cbf3894511c68e6a18b0.svg";